import { useEffect } from "react";
import { Link } from "react-router-dom";
import BaknayLogo from "../brand/BaknayLogo";
import AppFooter from "../footer/AppFooter";
import "./PublicShell.css";

function classNames(...parts) {
  return parts.filter(Boolean).join(" ");
}

export default function PublicShell({
  children,
  className = "",
  tagline,
  size = "default",
  brandTo = "/login",
  brandOnClick,
}) {
  const resolvedTagline =
    tagline === undefined
      ? "Borderless. Simple. Secure."
      : tagline;

  const rootClass = classNames("public-shell", className);
  const mainInnerClass = classNames(
    "public-shell__main-inner",
    `public-shell__main-inner--${size}`
  );

  useEffect(() => {
    if (typeof document === "undefined") return;
    const rootEl = document.getElementById("root");
    document.documentElement.classList.add("public-shell-theme");
    document.body.classList.add("public-shell-theme");
    rootEl?.classList.add("public-shell-theme");

    return () => {
      document.documentElement.classList.remove("public-shell-theme");
      document.body.classList.remove("public-shell-theme");
      rootEl?.classList.remove("public-shell-theme");
    };
  }, []);

  return (
    <div className={rootClass}>
      <div className="public-shell__bg" aria-hidden="true" />

      <header className="public-shell__header">
        <div className="public-shell__header-inner">
          <Link
            to={brandTo}
            onClick={brandOnClick}
            className="public-shell__brand"
            aria-label="Baknay home"
          >
            <BaknayLogo variant="dark" size="lg" />
          </Link>

          {resolvedTagline ? (
            <p className="public-shell__tagline">{resolvedTagline}</p>
          ) : null}
        </div>
      </header>

      <main className="public-shell__main">
        <div className={mainInnerClass}>{children}</div>
      </main>

      <AppFooter />
    </div>
  );
}
